exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clear-div {\r\n    float: right;\r\n}\r\n.clear-div span {\r\n    display: inline-block;\r\n    padding: 0px 5px;\r\n}\r\n\r\n.dataTables_wrapper table tr:hover { background: #E7F4FD; cursor: pointer;}\r\n\r\n.dataTables_wrapper table td.deleted-report { color: #BBBBBB; }\r\n\r\n.dataTables_wrapper table td.deleted-report-filename { color: #BBBBBB; text-decoration: underline;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/history/history.component.css
// module id = ../../../../../src/app/reports/myReports/history/history.component.css
// module chunks = main